var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiabetes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 28",
    style: {
      enableBackground: "new 0 0 35 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4B5A8;fill-opacity:0.5;}\n\t.st1{clip-path:url(#SVGID_00000141438058693113102890000008081101156188439172_);}\n\t.st2{fill:none;stroke:#A977F9;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 30,
    height: 27.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006681093201182336770000015203096584474739643_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000006681093201182336770000015203096584474739643_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.1,4.7c0,0,3.4-0.1,6.2-2.7C7.2,1.5,9.7-0.1,13.4,1c0.7,0.2,1.7,0.1,1.2,3c0.1,1.4-0.4,1.3,0.1,3.6 c0,0.7-0.6,2.7-2.6,1.7c-0.4-0.3-1-2.9-1-3C10.7,7.5,10.9,8.9,7,9.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.8,2.7h9.6c0,0,2.2-0.1,2.4,1.7c0,0.8-0.1,2-2.2,2.1c-2.4-0.1-9.9,0-9.9,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15,10.1h3.2c0,0,1.6,0,1.4,1.9c-0.1,0.6-0.3,1.3-1.6,1.6h-3.5c0,0-1.6-0.3-1.4-2 C13.3,11.2,13.4,10.1,15,10.1L15,10.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.1,14.9c0,0,2-0.3,3.7,0.6c1.7,0.9,2.7,1.8,6.5,1.8c1.9,0,3.5,0,3.5,0h3.5c0,0,1.4-0.2,1.6-1.8 c0-0.6,0.1-1.5-1.3-2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.8,17.3c0,0-1.4-0.4-1.4-1.9c0.1-0.7,0.3-1.6,2.1-1.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.4,9.1c0,0,1.5,1.3,1.6,2.7c0,0.5-0.5,1.7-2,1.4c-0.5-0.2-1.8-0.9-0.6-3C24.4,10.2,24.7,9.7,25.4,9.1 L25.4,9.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.5,16.3c0,0,4.9,4.5,3.8,7.9c-0.5,1.1-2.2,3.6-5.3,2.4c-0.7-0.4-4-1.8-1.4-6.8 C24,17.7,25.5,16.3,25.5,16.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.5,21.3v3.1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.9,22.8h2.9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.5,6.4c0,0,1.7,0.3,1.5,2c-0.2,0.6-0.3,1.3-1.7,1.7c-1.4,0-4.2-0.2-4.2-0.2s-0.8-0.1,0-0.8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiabetes);
export default __webpack_public_path__ + "static/media/Diabetes.194d7906870523240d2a8b186a14bde2.svg";
export { ForwardRef as ReactComponent };